import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
  Modal,
  ModalVariants,
} from "@hid-galaxy-ui/galaxy-react";
import { PartnerDetailType } from "../../../../../../redux/slices/partner-details/Types";
import { useAppDispatch, useAppSelector } from "../../../../../../redux";
import {
  getPartnerDetailsSagaAction,
  togglePartnerEnableSagaAction,
} from "../../../../../../redux/saga/partner-details/saga-actions";
import "./TogglePortalAccessModal.scss";

const TogglePortalAccessModal: React.FC<{
  partnerDetails: PartnerDetailType;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ partnerDetails, setModalOpen }) => {
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const { status } = useAppSelector((state) => state.partner_details);
  const dispatch = useAppDispatch();
  const headerMessage =
    partnerDetails.enable === 0
      ? "Please confirm that you want to enable portal access for this partner"
      : "Please confirm that you want to disable portal access for this partner";
  const buttonLabel =
    partnerDetails.enable === 0
      ? "Confirm and Enable Portal Access"
      : "Confirm and Disable Portal Access";
  const statusMessage =
    partnerDetails.enable === 0
      ? "Partner Portal Access Enabled"
      : "Partner Portal Access Disabled";

  const onConfirmButtonClick = () => {
    setSubmitted(true);
    dispatch(
      togglePartnerEnableSagaAction({
        ID: partnerDetails.ID,
        enable: partnerDetails.enable ? 0 : 1,
      })
    );
  };
  const footerConfig = submitted
    ? {}
    : {
        secondaryBtnLabel: "Cancel",
      };
  const onModalClose = () => {
    setModalOpen(false);
    if (submitted) dispatch(getPartnerDetailsSagaAction(partnerDetails.ID));
  };
  return (
    <Modal
      headerText="Confirmation"
      size={ModalVariants.Medium}
      footerConfig={footerConfig}
      onClose={() => onModalClose()}
      className="toggle-portal-access-modal"
    >
      {submitted ? (
        <div className="status-message-modal-container">
          {status.togglePartnerEnableLoading ? (
            <Loader variant={LoaderSizes.large} />
          ) : status.togglePartnerEnableStatus ? (
            <>
              <Iconography
                icon="circleCheck"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Success}
              />
              <div className="message">{statusMessage}</div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => onModalClose()}
              />
            </>
          ) : (
            <>
              <Iconography
                icon="circleXmark"
                size={IconographySizes.XLarge}
                theme={IconographyThemes.Error}
              />
              <div className="message">Something went wrong</div>
              <Button
                variant="primary"
                label="Continue"
                onClick={() => setModalOpen(false)}
              />
            </>
          )}
        </div>
      ) : (
        <div className="message-button-container">
          <p className="confirm-message">{headerMessage}</p>
          <div className="icon-wrapper">
            <Iconography icon="buildings" size={IconographySizes.Medium} />
          </div>
          <div className="name">{partnerDetails.partner_name}</div>
          <div className="status">{`${partnerDetails.status} Partner`}</div>
          <Button
            variant="primary"
            label={buttonLabel}
            onClick={onConfirmButtonClick}
          />
        </div>
      )}
    </Modal>
  );
};

export default TogglePortalAccessModal;
